import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

interface OpenGraphTagsProps {
  title: string;
  description: string;
  url: string;
  type?: string;
  image?: string;
  siteName?: string;
  category?: string;
  upvotes?: number;
}

export const OpenGraphTags: React.FC<OpenGraphTagsProps> = ({
  title,
  description,
  url,
  type = 'website',
  image,
  siteName = 'JiGSO EX Hub',
  category,
  upvotes
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      
      {/* Additional Meta Tags for Rich Previews */}
      {category && <meta property="article:section" content={category} />}
      {upvotes && <meta property="og:image:alt" content={`${title} - ${upvotes} upvotes`} />}
      
      {/* Robots and canonical */}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />
      
      {/* Structured Data for Rich Snippets */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": title,
          "description": description,
          "url": url,
          "applicationCategory": category || "BusinessApplication",
          "aggregateRating": upvotes ? {
            "@type": "AggregateRating",
            "ratingValue": upvotes,
            "ratingCount": upvotes
          } : undefined,
          "publisher": {
            "@type": "Organization",
            "name": siteName
          }
        })}
      </script>
    </Helmet>
  );
}; 